module.exports = __webpack_public_path__ + "img/koncertlogo.8624ecfa.png";